<template>
  <main class="bg-gradient">
    <!-- Discover your path text section -->
    <div class="md:px-12 max-w-screen-2xl mx-auto py-4 mt-10 mb-10 text-white">
      <h1 class="text-center text-lg font-black mt-10">FUNFACTS</h1>
      <p class="text-center text-2xl mt-3">
        Discover Some Fun Facts About Barka
      </p>
    </div>

    <!-- Discover your path card section -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-0 mt-10">
      <!-- Person card -->
      <div
        v-for="(person, index) in persons"
        :key="index"
        class="group relative overflow-hidden"
      >
        <!-- Image -->
        <img
          :src="person.image"
          alt="person image"
          class="w-full h-full object-cover transition-transform duration-500 transform group-hover:scale-105"
        />

        <!-- Title inside image (at the bottom) -->
        <div
          class="absolute top-8 left-0 right-0 bg-opacity-10 text-white font-black text-2xl text-center z-10 transition-opacity duration-500"
        >
          <span>
            {{ person.title }}
          </span>
        </div>

        <!-- Hover effect (description with transparent dark background) -->
        <div
          class="absolute inset-0 bg-[#945a12] bg-opacity-70 flex items-center justify-center text-center text-white opacity-0 group-hover:opacity-100 duration-500 z-20 transform translate-x-full group-hover:translate-x-0 transition-transform"
        >
          <div
            class="absolute top-8 left-0 right-0 bg-opacity-10 text-white font-black text-2xl text-center z-10 transition-opacity duration-500"
          >
            <!-- Title -->
            <span>{{ person.title }}</span>

            <!-- HR line, only visible on hover -->
            <hr
              class=" w-40 h-1 mx-auto bg-gray-100 border-0 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-500"
            />
          </div>
          <p class="px-4">{{ person.description }}</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      persons: [
        {
          title: "FunFact #1",
          image: require("../assets/images/poet.png"),
          description:
            "The Mshel Club: An exclusive mentorship circle by Barka U. Mshelia. Join now and enjoy the benefits of the Realestate community.",
        },
        {
          title: "FunFact #2",
          image: require("../assets/images/badminton-image.jpg"),
          description:
            "A renowned speaker who uses the power of storytelling and insight.",
        },
        {
          title: "FunFact #3",
          image: require("../assets/images/funfact.jpeg"),
          description:
            "A Growth Fund: Pioneering paths in venture capital, Mshel Group fuels the ambitions of next-gen entrepreneurs.",
        },
        {
          title: "FunFact #4",
          image: require("../assets/images/main-cv.jpg"),
          description:
            "School of Scale: A platform custom built to equip entrepreneurs looking to scale their businesses.",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* Hover scale effect for image */
.group-hover\:scale-105 {
  transform: scale(1.05);
}

/* Smooth transition for the description and opacity */
.group-hover\:opacity-100 {
  opacity: 1;
}
.transition-opacity {
  transition: opacity 0.5s ease;
}
.transition-transform {
  transition: transform 0.5s ease;
}
.text-2xl {
  font-size: 18px !important;
  font-weight: bolder !important;
}
.opacity-0 {
  opacity: 0;
}
.group-hover\:opacity-100 {
  opacity: 1;
}
</style>
